import type { IConfig } from '@shared/app/scripts/services/config';
import { Domain } from '@shared/app/scripts/services/domain';

/*
 * The endpoint service returns the current endpoint depending on the build type
 */
export class Endpoint {
  constructor(
    private $location: ng.ILocationService,
    private config: IConfig,
    private domain: Domain,
  ) {}

  getBaseEndpoint = () => {
    // TODO port part probably can be deprecated - with v7 like set up we don't
    // support ports
    const port = this.$location.port() ? ':' + this.$location.port() : '';
    const base = this.$location.host() + port;
    return '//' + base;
  };

  get = () => {
    return this.getBaseEndpoint();
  };

  getSoftwearEndpoint = () => {
    return '//posfeed.softwear.nl';
  };

  getSpynlEndpoint = () => {
    return '//' + this.domain.sibling(this.config.spynlSubdomain);
  };

  getPDFEndpoint = () => {
    return '//' + this.domain.sibling('spynl-services');
  };

  getPipeEndpoint = () => {
    return '//' + this.domain.sibling('spynl-services');
  };

  getUploadEndpoint = () => {
    return '//' + this.domain.sibling('spynl-services');
  };

  getLegacyEndpoint = () => {
    return '//www.softwear.nl/posapi';
  };

  getPayPlazaV4Endpoint = () => {
    return '//' + this.domain.sibling('payplaza') + '/api/ecr/4';
  };
}

angular
  .module('v6CoreModule')
  .factory('endpoint', ($location, config, domain) => {
    return new Endpoint($location, config, domain);
  });
